export enum FilesD177 {
  CONTRACT = '/files/contract_sponsorD177.pdf',
  FORM = '/files/form_sponsorD177.pdf',
}
